import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Translate } from '~/i18n';
import { DealsIcon, PointsIcon, UserIcon } from '~/svgs/benifits-section';
import { isJarir } from '~/utils/theme';
import { Fragment } from 'react';
import Container from '../common/container';

interface BoxProps {
   title: React.ReactNode;
   subtitle: React.ReactNode;
   icon: React.ReactNode;
}

const Box = ({ title, subtitle, icon }: BoxProps) => {
   const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.7, rootMargin: '50px' });

   const variants = {
      hide: {
         opacity: 0,
      },
      show: {
         opacity: 1,
      },
   };
   return (
      <div ref={ref}>
         <div className="flex">
            <div className="ltr:mr-8 rtl:ml-8">
               <motion.div
                  initial={{ scale: 0 }}
                  animate={{ scale: inView ? 1 : 0 }}
                  transition={{ ease: 'backOut', duration: 0.35 }}>
                  {icon}
               </motion.div>
            </div>
            <div>
               <motion.span
                  variants={variants}
                  initial="hide"
                  animate={inView ? 'show' : 'hide'}
                  className="block mb-3 font-bold">
                  {title}
               </motion.span>
               <motion.span
                  variants={variants}
                  initial="hide"
                  animate={inView ? 'show' : 'hide'}
                  className="break-words">
                  {subtitle}
               </motion.span>
            </div>
         </div>
      </div>
   );
};

const BookingBenifitsSection = () => {
   return (
      <Fragment>
         {isJarir ? null : (
            <section className="py-12 border-t border-b border-gray-50 text-primary-focus">
               <Container>
                  <span className="block mt-2 mb-6 text-2xl font-bold leading-none">
                     <Translate id="benifits:why book on halayalla" />
                  </span>
                  <div className="pb-20 lg:pb-0">
                     <div className="grid grid-cols-1 lg:grid-cols-3 md:grid-cols-2 md:gap-x-4 lg:gap-y-0 gap-y-4">
                        <Box
                           icon={<DealsIcon />}
                           title={<Translate id="benifits:best deals" />}
                           subtitle={<Translate id="benifits:best deals subtitle" />}
                        />
                        {/* {is_dmc ? null : (
                           <Box
                              icon={<RefundIcon />}
                              title={<Translate id="benifits:refund title" />}
                              subtitle={<Translate id="benifits:refund subtitle" />}
                           />
                        )} */}
                        <Box
                           icon={<UserIcon />}
                           title={<Translate id="benifits:user title" />}
                           subtitle={<Translate id="benifits:user subtitle" />}
                        />
                        <Box
                           icon={<PointsIcon />}
                           title={<Translate id="benifits:points title" />}
                           subtitle={<Translate id="benifits:points subtitle" />}
                        />
                     </div>
                  </div>
               </Container>
            </section>
         )}
      </Fragment>
   );
};

export default BookingBenifitsSection;
